type ComposeFunction<T, U> = (state: T) => U;

/**
 * @desc Compose functions from left to right starting with undefined for first function
 * @example
 * const result: TransformState2 = pipeCompose(
 * () => initState,
 * (state) => transformState1(state),
 * (state) => transformState2(state),
 * )
 *
 */
export function pipeCompose<A>(op1: ComposeFunction<undefined, A>): A;
export function pipeCompose<A, B>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
): B;
export function pipeCompose<A, B, C>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
): C;
export function pipeCompose<A, B, C, D>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
): D;
export function pipeCompose<A, B, C, D, E>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
): E;
export function pipeCompose<A, B, C, D, E, F>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
): F;
export function pipeCompose<A, B, C, D, E, F, G>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
): G;
export function pipeCompose<A, B, C, D, E, F, G, H>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
): H;
export function pipeCompose<A, B, C, D, E, F, G, H, I>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
): I;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
): J;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J, K>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
  op11: ComposeFunction<J, K>,
): K;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J, K, L>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
  op11: ComposeFunction<J, K>,
  op12: ComposeFunction<K, L>,
): L;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J, K, L, M>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
  op11: ComposeFunction<J, K>,
  op12: ComposeFunction<K, L>,
  op13: ComposeFunction<L, M>,
): M;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J, K, L, M, N>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
  op11: ComposeFunction<J, K>,
  op12: ComposeFunction<K, L>,
  op13: ComposeFunction<L, M>,
  op14: ComposeFunction<M, N>,
): N;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J, K, L, M, N, O>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
  op11: ComposeFunction<J, K>,
  op12: ComposeFunction<K, L>,
  op13: ComposeFunction<L, M>,
  op14: ComposeFunction<M, N>,
  op15: ComposeFunction<N, O>,
): O;
export function pipeCompose<A, B, C, D, E, F, G, H, I, J, K, L, M, N, O>(
  op1: ComposeFunction<undefined, A>,
  op2: ComposeFunction<A, B>,
  op3: ComposeFunction<B, C>,
  op4: ComposeFunction<C, D>,
  op5: ComposeFunction<D, E>,
  op6: ComposeFunction<E, F>,
  op7: ComposeFunction<F, G>,
  op8: ComposeFunction<G, H>,
  op9: ComposeFunction<H, I>,
  op10: ComposeFunction<I, J>,
  op11: ComposeFunction<J, K>,
  op12: ComposeFunction<K, L>,
  op13: ComposeFunction<L, M>,
  op14: ComposeFunction<M, N>,
  op15: ComposeFunction<N, O>,
  ...transformFns: Array<ComposeFunction<I, any>>
): unknown;
export function pipeCompose(...transformFns: Array<ComposeFunction<any, any>>): unknown {
  return transformFns.reduce((previousState, transformFn) => transformFn(previousState), undefined);
}
